/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Content_Sound_TitleInputs */

const en_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy various tree species and sounds for free`)
};

const ar_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استمتع بأنواع مختلفة من الأشجار والأصوات مجانًا`)
};

const de_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genießen Sie kostenlos verschiedene Baumarten und Klänge`)
};

const es_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfruta gratis de varias especies de árboles y sonidos`)
};

const fr_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez gratuitement une variété d'arbres et de sons apaisants`)
};

const it_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goditi gratuitamente diverse specie di alberi e suoni`)
};

const ja_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さまざまな樹種やサウンドが無料`)
};

const ko_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다양한 나무와 사운드를 무료로 즐기세요`)
};

const pt_br_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproveite diversas espécies de árvore e sons gratuitamente`)
};

const ru_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Различные виды деревьев и звуки бесплатно`)
};

const th_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพลิดเพลินไปกับพันธุ์ต้นไม้หลากหลายชนิดและเสียงต่าง ๆ ฟรี`)
};

const tr_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çeşitli ağaç türlerinin ve seslerinin keyfini ücretsiz olarak çıkar`)
};

const zh_cn_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费使用多种树种和声音`)
};

const zh_tw_subscription_exclusive_content_sound_title = /** @type {(inputs: Subscription_Exclusive_Content_Sound_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費使用多種樹種和聲音`)
};

/**
* | output |
* | --- |
* | "Enjoy various tree species and sounds for free" |
*
* @param {Subscription_Exclusive_Content_Sound_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_content_sound_title = /** @type {((inputs?: Subscription_Exclusive_Content_Sound_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Content_Sound_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_content_sound_title(inputs)
	if (locale === "ar") return ar_subscription_exclusive_content_sound_title(inputs)
	if (locale === "de") return de_subscription_exclusive_content_sound_title(inputs)
	if (locale === "es") return es_subscription_exclusive_content_sound_title(inputs)
	if (locale === "fr") return fr_subscription_exclusive_content_sound_title(inputs)
	if (locale === "it") return it_subscription_exclusive_content_sound_title(inputs)
	if (locale === "ja") return ja_subscription_exclusive_content_sound_title(inputs)
	if (locale === "ko") return ko_subscription_exclusive_content_sound_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_content_sound_title(inputs)
	if (locale === "ru") return ru_subscription_exclusive_content_sound_title(inputs)
	if (locale === "th") return th_subscription_exclusive_content_sound_title(inputs)
	if (locale === "tr") return tr_subscription_exclusive_content_sound_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_content_sound_title(inputs)
	return zh_tw_subscription_exclusive_content_sound_title(inputs)
});